import { useQueryClient as useTanstackQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import type { QueryKey } from '~/types/query-key'

export function useQueryClientHelper() {
  const queryClient = useTanstackQueryClient()

  const invalidateQueries = useCallback(
    (queryKey: QueryKey) => {
      return queryClient.invalidateQueries({ queryKey: [queryKey] })
    },
    [queryClient],
  )

  return { invalidateQueries, queryClient }
}
